document.addEventListener('DOMContentLoaded', function() {
  const reviewsSwiper = document.querySelector('.product-reviews-swiper');
  
  if (reviewsSwiper && typeof Swiper !== 'undefined') {
    new Swiper(reviewsSwiper, {
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      loop: false,
    });
  }
});
